module.exports = __webpack_public_path__ + "img/transport.0a210fad.png";